<template>
  <div>
    <el-menu class="navbar-top" mode="horizontal">
      <img src="@/assets/image/in-vtic.png" id="topLogo">
      <div class="right-menu">
        <!--        <el-tooltip content="全屏" effect="dark" placement="bottom">-->
        <!--          <screenfull class="screenfull right-menu-item" />-->
        <!--        </el-tooltip>-->
        <el-tooltip class="item" effect="dark" placement="bottom" content="离线下载">
          <el-button type="text" icon="el-icon-download" circle @click="showDownloadList"></el-button>
        </el-tooltip>
        <el-dropdown
          class="userinfo-container right-menu-item"
          trigger="click"
          @command="handleCommand"
        >
          <div class="username-wrapper">
            <span class="">{{ username }}</span>
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <el-dropdown-item command="dashboard" style="text-align: center;"
              >主页</el-dropdown-item
            >
            <el-dropdown-item divided command="resetPwd">
              <span style="display:block;">重置密码</span>
            </el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <span style="display:block;">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-menu>
    <el-dialog
      title="重置密码"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="pwdFormTemp"
        ref="pwdForm"
        :rules="pwdFormRules"
        label-width="80px"
      >
        <el-form-item label="当前密码" prop="currentPwd">
          <input type="text" style="display: none;" />
          <input type="password" style="display: none;" />
          <el-input
            type="text"
            v-model="pwdFormTemp.currentPwd"
            autocomplete="off"
            placeholder="请输入当前密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pwd1">
          <el-input
            type="text"
            v-model="pwdFormTemp.pwd1"
            autocomplete="new-password"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="pwd2">
          <el-input
            type="text"
            v-model="pwdFormTemp.pwd2"
            autocomplete="new-password"
            placeholder="再次输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="saveNewPassword"
          v-loading="saveLodingState"
          >确认修改</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
        title="下载列表"
        :visible.sync="downloadListVisible"
        width="60%">
      <el-table
          :data="downloadTable"
          style="width:100%">
        <el-table-column prop="taskStatus" label="任务状态" :formatter="taskStatusFormatter"></el-table-column>
        <el-table-column prop="taskType" label="业务类型" :formatter="taskTypeFormatter"></el-table-column>
        <el-table-column prop="downloadStatus" label="下载状态" :formatter="downloadStatusFormatter"></el-table-column>
        <el-table-column label="下载地址">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" placement="top" content="点击复制下载链接"
                        v-if="scope.row.downloadStatus === 1 && scope.row.url != null && scope.row.url != ''">
              <el-button size="small" @click="copy(scope.$index, scope.row)"
                         v-if="scope.row.downloadStatus === 1 && scope.row.url != null && scope.row.url != ''">
                下载链接
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
                v-if="scope.row.taskStatus === 2 && scope.row.downloadStatus === 1"
                @click="downloadReportZipUrlAsync(scope.row)"
                size="small">下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { logout, updateCurrentPassword } from "@/api/auth";
import {downloadReportZipUrlAsync, getDownloadList} from '@/api/userAssess';
import capm from '@/assets/image/in-capm.png'
import chinatest from '@/assets/image/in-chinatest.png'
import shzz from '@/assets/image/in-shzzfw.png'

export default {
  data: function() {
    const validateNewPassword = (rule, value, callback) => {
      if (value != null && value !== "") {
        if (this.pwdForm.pwd1 !== this.pwdForm.pwd2) {
          callback(new Error("两次输入密码不一致"));
        } else {
          callback();
        }
      } else {
        callback(new Error("确认密码不能为空"));
      }
    };
    return {
      pwdForm: {
        currentPwd: null,
        pwd1: null,
        pwd2: null
      },
      pwdFormTemp: {
        currentPwd: null,
        pwd1: null,
        pwd2: null
      },
      pwdFormRules: {
        currentPwd: [
          { required: true, message: "当前密码不能为空", trigger: "blur" }
        ],
        pwd1: [{ required: true, message: "新密码不能为空", trigger: "blur" }],
        pwd2: [{ validator: validateNewPassword, trigger: "blur" }]
      },
      dialogFormVisible: false,
      saveLodingState: false,
      downloadListVisible: false,
      downloadTable: [
        {
          id: null,
          url: null,
          downloadUrl: null,
          taskStatus: null,
          downloadStatus: null,
        },
      ],
    };
  },
  components: {
  },
  computed: {
    ...mapGetters(["username"])
  },
  watch: {
    "pwdFormTemp.currentPwd": function(val) {
      this.flushPassword(val, "currentPwd", "currentPwd");
    },
    "pwdFormTemp.pwd1": function(val) {
      this.flushPassword(val, "pwd1", "pwd1");
    },
    "pwdFormTemp.pwd2": function(val) {
      this.flushPassword(val, "pwd2", "pwd2");
    }
  },
  mounted(){
    if (localStorage.getItem('ft') === 'pjw') {
      document.getElementById('topLogo').src = capm
    } else if (localStorage.getItem('ft') === 'wpc') {
      document.getElementById('topLogo').src = chinatest
    }else if (localStorage.getItem('ft') === 'shzz'){
      document.getElementById('topLogo').src = shzz
    }
    window.showDownloadList = this.showDownloadList;
  },
  methods: {
    flushPassword: function(val, item1, item2) {
      if (val) {
        let n = val.search(/(?!●)./);
        if (n >= 0) {
          let word = val.substr(n, 1);
          if (n === 0 && this.pwdForm[item2] == null) {
            this.pwdForm[item2] = word;
          } else {
            if (n === item2.length) {
              this.pwdForm[item2] += word;
            } else {
              let subStr1 = this.pwdForm[item2].substr(0, n);
              let subStr2 = this.pwdForm[item2].substring(n);
              this.pwdForm[item2] = subStr1 + word + subStr2;
            }
          }
          this.pwdFormTemp[item1] = this.pwdFormTemp[item1].replace(
            /(?!●)./,
            "●"
          );
        }
      } else {
        this.pwdForm[item2] = null;
      }
    },
    handleCommand(command) {
      if (command === "dashboard") {
        var currentPath = this.$router.currentRoute.path.replace("/", "");
        if (currentPath === "dashboard") {
          console.log("visitedViews", this.$store.state.tagsView.visitedViews);
          var visitedViews = this.$store.state.tagsView.visitedViews;
          if (!visitedViews || visitedViews.length === 0) {
            this.$router.go(0);
          } else {
            this.$router.push({ path: "/dashboard" });
          }
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      } else if (command === "logout") {
        this.logoutHandler();
      } else if (command === "resetPwd") {
        //修改密码，首先清空form
        this.pwdFormTemp.currentPwd = null;
        this.pwdFormTemp.pwd1 = null;
        this.pwdFormTemp.pwd2 = null;
        this.pwdForm.currentPwd = null;
        this.pwdForm.pwd1 = null;
        this.pwdForm.pwd2 = null;
        this.dialogFormVisible = true;
      }
    },
    logoutHandler() {
      //let self = this;
      let store = this.$store;
      logout()
        .then()
        .finally(() => {
          this.$store.dispatch("clearAccessInfo").then(() => {
            store.dispatch("clearRoutes").then(() => {
              setTimeout(() => {
                if (localStorage.getItem('loginRoute')) {
                  try {
                    let route = JSON.parse(localStorage.getItem('loginRoute'))
                    this.$router.push(route)
                  } catch (e) {
                    this.$router.push('/login')
                  }
                } else {
                  this.$router.push('/login')
                }
              }, 500);
            });
          });
        });
    },
    saveNewPassword: function() {
      let self = this;
      //保存新密码
      this.$refs["pwdForm"].validate(valid => {
        if (valid) {
          self.saveLodingState = true;
          updateCurrentPassword(self.pwdForm.currentPwd, self.pwdForm.pwd2)
            .then(res => {
              if (res.code === 200) {
                this.$message.success("更新成功！");
                self.dialogFormVisible = false;
              }
            })
            .finally(() => {
              self.saveLodingState = false;
            });
          return true;
        } else {
          return false;
        }
      });
    },
    showDownloadList() {
      let that = this;
      that.downloadListVisible = true;
      getDownloadList().then((res) => {
        if (res && res.code === 200) {
          this.downloadTable = res.data.list;
        }
      });
    },
    taskStatusFormatter(row, column, cellValue) {
      let taskStatus = cellValue;
      switch (taskStatus) {
        case 1:
          return '进行中';
        case 2:
          return '已完成';
        default:
          return '异常';
      }
    },
    taskTypeFormatter(row, column, cellValue) {
      let taskType = cellValue;
      switch (taskType) {
        case 1:
          return '批量下载考场报告';
        default:
          return '';
      }
    },
    downloadStatusFormatter(row) {
      let status = row.downloadStatus;
      switch (status) {
        case 1:
          return '未下载';
        case 2:
          return '已下载';
        default:
          return '';
      }
    },
    copy(index, row) {
      let copyData = this.getDownloadUrl(row.id);
      let input = document.createElement('input');
      input.value = copyData;
      document.body.appendChild(input);
      input.select();
      document.execCommand('Copy');
      this.$message({
        message: '复制成功',
        type: 'success',
      });
      document.body.removeChild(input);
    },
    downloadReportZipUrlAsync(row) {
      downloadReportZipUrlAsync(row.id).then((res) => {
        if (res) {
          if (!res) {
            this.$message.error('下载文件失败');
            return false;
          }
          this.createReportVisible = false;
          this.isFinish = false;
          const blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          const downloadElement = document.createElement('a');
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers['content-disposition']; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*');
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = 'none';
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.showDownloadList();
        }
      });
    },
    getDownloadUrl(id) {
      return 'http://g.chinavtic.com' + '/api/open/downloadReportZipUrl/' + id;
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar-top {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  #topLogo {
    float: left;
    height: 100%;
    margin-left: 10px;
  }

  .right-menu {
    float: right;
    height: 100%;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .screenfull {
    }
    .userinfo-container {
      height: 50px;
      margin-right: 30px;
      .username-wrapper {
        cursor: pointer;
        font-weight: normal;
        color: #303133;
        display: flex;
        align-items: center;
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
